import {
  GET_PRODUCTTYPE,
  GET_PRODUCTTYPE_SUCCESS,
  GET_PRODUCTTYPE_FAIL,
  DELETE_PRODUCTTYPE,
  DELETE_PRODUCTTYPE_SUCCESS,
  DELETE_PRODUCTTYPE_FAIL,
  UPDATE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE_SUCCESS,
  UPDATE_PRODUCTTYPE_FAIL,
  ADD_NEW_PRODUCTTYPE,
  ADD_PRODUCTTYPE_SUCCESS,
  ADD_PRODUCTTYPE_FAIL,
  PRODUCTTYPE_LOADING,
  PRODUCTTYPE_RESET,
} from "./actionType";

export const resetProductTypeState = (actionType) => ({
  type: PRODUCTTYPE_RESET,
  payload: { actionType },
});

export const getProductTypeSuccess = (actionType, data) => ({
  type: GET_PRODUCTTYPE_SUCCESS,
  payload: { actionType, data },
});

export const getProductTypeFail = (actionType, error) => ({
  type: GET_PRODUCTTYPE_FAIL,
  payload: { actionType, error },
});

export const getProductType = (data, path) => ({
  type: GET_PRODUCTTYPE,
  payload: data,
  path,
});

export const getProductTypeLoading = () => ({
  type: PRODUCTTYPE_LOADING,
});

export const deleteProductType = (data) => ({
  type: DELETE_PRODUCTTYPE,
  payload: data,
});

export const deleteProductTypeSuccess = (data) => ({
  type: DELETE_PRODUCTTYPE_SUCCESS,
  payload: data,
});

export const deleteProductTypeFail = (error) => ({
  type: DELETE_PRODUCTTYPE_FAIL,
  payload: error,
});

export const updateProductType = (data) => ({
  type: UPDATE_PRODUCTTYPE,
  payload: data,
});

export const updateProductTypeFail = (error) => ({
  type: UPDATE_PRODUCTTYPE_FAIL,
  payload: error,
});

export const updateProductTypeSuccess = (data) => ({
  type: UPDATE_PRODUCTTYPE_SUCCESS,
  payload: data,
});

export const addNewProductType = (data) => ({
  type: ADD_NEW_PRODUCTTYPE,
  payload: data,
});

export const addProductTypeSuccess = (data) => ({
  type: ADD_PRODUCTTYPE_SUCCESS,
  payload: data,
});

export const addProductTypeFail = (error) => ({
  type: ADD_PRODUCTTYPE_FAIL,
  payload: error,
});
